/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractFinderGridDefinition } from '@gh/common-internal-shared';
import { TranslationService } from '@gh/core-mls';
import { ColDef, GridOptions } from 'ag-grid-community';
import { getComponentItemFinderListItemUniqueId } from '../../resources/component-item-finder-list-item.model';
import { ColumnWidthPersistenceService } from '@gh/common-internal-shared';
import { buildNumberColumn } from '@gh/core-ui-grid';
import { NumberTypes } from '@gh/common-shared';

@Injectable()
export class ComponentItemFinderGridDefinition extends AbstractFinderGridDefinition {
  getId = getComponentItemFinderListItemUniqueId;

  private readonly STORAGE_KEY = 'componentItemFinder:columnWidths';

  constructor(private translationService: TranslationService, 
              private columnWidthService: ColumnWidthPersistenceService) {
    super();
  }

  buildColumnDefs(): ColDef[] {
    return [
      { field: 'code', headerName: this.translationService.get('lbl_code'), width: this.columnWidthService.getColumnWidth(this.STORAGE_KEY, 'code', 170) },
      { field: 'name', headerName: this.translationService.get('lbl_description'), width: this.columnWidthService.getColumnWidth(this.STORAGE_KEY, 'name', 415) },
      { field: 'uomCode', headerName: this.translationService.get('lbl_uom_abbreviation'), width: this.columnWidthService.getColumnWidth(this.STORAGE_KEY, 'uomCode', 95) },
      { ...buildNumberColumn(NumberTypes.Price, false), field: 'cost', headerName: this.translationService.get('Price'), width: this.columnWidthService.getColumnWidth(this.STORAGE_KEY, 'cost', 100) },
    ];
  }

  buildGridOptions(): GridOptions {
    return {
      ...super.buildGridOptions(),
      onColumnResized: this.columnWidthService.createColumnResizedHandler(this.STORAGE_KEY),
    };
  }
}
